export default "__VITE_ASSET__04445391__"